(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    for (const bar of document.querySelectorAll('.menu-list--mobile')) {
    const selected = bar.querySelector('[data-fr-nav-selected="true"]');
    const scroller = bar.querySelector('.menu-list__scroll-container');
    if (selected && scroller) {
      scroller.scrollLeft = Math.max(0, selected.offsetLeft - (scroller.clientWidth - selected.offsetWidth) / 2);
    }
  }
  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-fr-nav-trigger]') : null;
    const item = trigger?.closest('[data-fr-nav-item]');
    if (!item) return;
    for (const sibling of item.parentElement.children) {
      if (sibling.hasAttribute('data-fr-nav-item')) {
        sibling.setAttribute('data-fr-nav-selected', String(sibling === item));
      }
    }
  }, { capture: true });
  } catch(e) { console.error(e); }
})();

})();
